import './Units.scss'

import { HDSRadio, HDSRadioGroup } from '@here/hds-react-components'
import CloseButton from 'components/App/components/CloseButton'
import { ScrollableContainer } from 'components/App/components/ScrollableContainer'
import { RootState } from 'data/reducer'
import { setUnit } from 'data/reducer/app'
import { useAppDispatch, useAppSelector } from 'data/store/hooks'
import { i18n } from 'lib/i18n'
import React, { useCallback } from 'react'
import { UnitType, updateUnit } from 'utils/storage'

interface UnitsProps {
  onClose: () => void
}

export const Units = React.forwardRef(function Units(
  { onClose }: UnitsProps,
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const dispatch = useAppDispatch()
  const unit: string = useAppSelector((state: RootState) => state.app.unit)

  const changeUnit = useCallback(
    (value: string) => {
      updateUnit(value)
      dispatch(setUnit(value))
    },
    [dispatch]
  )

  return (
    <div className="Units" data-testid="units" ref={ref}>
      <div className="Units__header" data-testid="units-title">
        {i18n('account.settings.units.title')}
        <CloseButton onClick={onClose} />
      </div>
      <ScrollableContainer>
        <React.Fragment>
          <div className="Units__content">
            <React.Fragment>
              <HDSRadioGroup
                vertical
                name="distance"
                label={i18n('account.settings.units.distance.title')}
                onChange={(e) => changeUnit(e.detail.value)}
                data-testid="units-radio-group"
              >
                <HDSRadio
                  className="Units__radio"
                  value={UnitType.automatic}
                  checked={unit === UnitType.automatic}
                >
                  {i18n('account.settings.units.distance.default.title')}
                  <span slot="description">
                    {i18n('account.settings.units.distance.default.description')}
                  </span>
                </HDSRadio>
                <HDSRadio
                  className="Units__radio"
                  value={UnitType.metric}
                  checked={unit === UnitType.metric}
                >
                  {i18n('account.settings.units.distance.metric.title')}
                  <span slot="description">
                    {i18n('account.settings.units.distance.metric.description')}
                  </span>
                </HDSRadio>
                <HDSRadio
                  className="Units__radio"
                  value={UnitType.imperialUK}
                  checked={unit === UnitType.imperialUK}
                >
                  {i18n('account.settings.units.distance.imperial-uk.title')}
                  <span slot="description">
                    {i18n('account.settings.units.distance.imperial-uk.description')}
                  </span>
                </HDSRadio>
                <HDSRadio
                  className="Units__radio"
                  value={UnitType.imperialUS}
                  checked={unit === UnitType.imperialUS}
                >
                  {i18n('account.settings.units.distance.imperial-us.title')}
                  <span slot="description">
                    {i18n('account.settings.units.distance.imperial-us.description')}
                  </span>
                </HDSRadio>
              </HDSRadioGroup>
            </React.Fragment>
          </div>
        </React.Fragment>
      </ScrollableContainer>
    </div>
  )
})
